import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from "recoil";
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './style.css';

ReactDOM.render((
  <RecoilRoot>
    <BrowserRouter basename="/app">
      <App site={document.getElementById('root').getAttribute('data-site')} />
    </BrowserRouter>
  </RecoilRoot>
), document.getElementById('root'));

serviceWorker.unregister();
